import { useEffect, useRef, type ReactNode } from 'react';
import { useLocation } from 'react-router';

/**
 * Каркас экрана на всю высоту: прокручивается только контент, нижнее меню
 * стоит внизу обычным блоком. Скролл сбрасывается при смене раздела.
 */
export function AppFrame({
  children,
  nav,
  overlay,
  wide = false,
}: {
  children: ReactNode;
  nav: ReactNode;
  overlay?: ReactNode;
  wide?: boolean;
}) {
  const width = wide ? 'max-w-3xl' : 'max-w-xl';
  const scroller = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  useEffect(() => {
    scroller.current?.scrollTo({ top: 0 });
  }, [pathname]);
  return (
    <div className="fixed inset-0 flex flex-col bg-body">
      <div ref={scroller} data-app-scroll className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
        <div className={`mx-auto w-full ${width}`}>{children}</div>
      </div>
      <div className={`mx-auto w-full ${width}`}>{nav}</div>
      {overlay}
    </div>
  );
}
